import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActionSheetController, Platform } from '@ionic/angular';
import { GenericAddStepOneModelEnum } from 'src/app/pages/generic-add-step-one/generic-add-step-one-model-enum';
import { PermissionCheckerService } from 'src/app/services/permission-checker/permission-checker.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {

  customerPermissions: boolean;
  equipmentPermissions: boolean;
  recommendationsPermissions: boolean;
  quotesPermissions: boolean;
  canUseSurveyCustomer: boolean;
  isReadOnly: boolean;
  app_version: string;
  
  actionSheet: any;

  constructor(
    private router: Router,
    private actionSheetCtrl: ActionSheetController,
    private platform: Platform,
    private permissionChecker: PermissionCheckerService) { 
      this.app_version = environment.APP_VERSION;
    }

  ngOnInit() { }

  async presentActionSheet() {
    var buttons = await this.getActionSheetOptions();

    this.actionSheet = await this.actionSheetCtrl.create({
      header: 'Choose an Action',
      buttons: buttons
    });

    await this.actionSheet.present();
  }

  async getActionSheetOptions() {

    this.customerPermissions = await this.permissionChecker.canCRUDCustomers();
    this.equipmentPermissions = await this.permissionChecker.canCRUDEquipments();
    this.recommendationsPermissions = await this.permissionChecker.canCRUDRecommendations();
    this.quotesPermissions = await this.permissionChecker.canCRUDQuotes();
    this.canUseSurveyCustomer = await this.permissionChecker.canUseSurveyCustomer();
    this.isReadOnly = await this.permissionChecker.isReadOnly();
    
    var buttonsForSheet = [];

    if (!this.isReadOnly && this.canUseSurveyCustomer) {
      buttonsForSheet.push({
        text: 'Contract Survey Prospect Customer',
        icon: !this.platform.is('ios') ? 'add' : null,
        handler: async () => {
          await this.actionSheet.dismiss();
          this.router.navigate(['/survey-prospect-customer-add']);
        }
      });
    }

    if (this.customerPermissions) {
      buttonsForSheet.push({
        text: 'Service Call Prospect Customer',
        icon: !this.platform.is('ios') ? 'add' : null,
        handler: () => {
          this.router.navigate(['/customer-add']);
        }
      });
    }

    if (this.recommendationsPermissions) {
      buttonsForSheet.push({
        text: 'Recommendation',
        icon: !this.platform.is('ios') ? 'add' : null,
        handler: () => {
          this.router.navigate(['select-customer', GenericAddStepOneModelEnum.RECOMMENDATION ]);
        }
      });
    }

    if (this.quotesPermissions) {
      buttonsForSheet.push({
        text: 'Quotes',
        icon: !this.platform.is('ios') ? 'add' : null,
        handler: () => {
          this.router.navigate(['select-customer', GenericAddStepOneModelEnum.QUOTE ]);
        }
      });
    }

    buttonsForSheet.push({
      text: 'Cancel',
      role: 'cancel',
      icon: !this.platform.is('ios') ? 'close' : null,
      handler: () => {
        console.log('Cancel clicked');
      }
    });

    return buttonsForSheet;
  }
}
